import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const BillingAccountSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default BillingAccountSVG;
